import { useEffect } from 'react';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import Banner from './components/Banner';
import { GoTop, ChatBox } from './style';
import useResize from '@/hooks/useResize';
import { Box } from '@/layout';
import StrategicPartners from './StrategicPartners';
import { useAppSelector } from '@/redux/store.hook';
import { getAuthSelector, switchLayout } from '@/redux/auth/auth.slice';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { WhatsApp } from '@/components/Icon';

const Index = () => {
  // @ts-ignore
  const { t, i18n } = useTranslation();
  const { isTablet, isMobile } = useResize();
  const auth = useAppSelector(getAuthSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 檢測是否為guest帳號, 若login為true且accessToken為空, 則將login設為false
    if (!auth.isLogin || auth.accessToken) return;
    dispatch(switchLayout(false));
  }, [auth, dispatch]);

  // 檢測location.pathname, 若為'/'則跳轉至當前語系的首頁
  useEffect(() => {
    const currentPath = location.pathname;
    const lang = currentPath.split('/')[1];
    const isValidLang = ['sc', 'tc', 'en'].includes(lang);

    if (!isValidLang) {
      const targetLang = i18n.language || 'en';
      window.location.replace(`/${targetLang}`);
    }
  }, []);

  return (
    <div>
      <Box position={'relative'} zIndex={0}>
        <Banner />
        <StrategicPartners />
        <Footer />
        <GoTop
          isTablet={isTablet}
          isMobile={isMobile}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          {t('top')}
        </GoTop>
        <ChatBox
          isTablet={isTablet}
          isMobile={isMobile}
          href="https://wa.me/85266981322"
          target='_blank'
        >
          <p>
            {t('chatWithUs')}
          </p>
          <WhatsApp.WhatsAppSVG width={25} height={25} />
        </ChatBox>
      </Box>
    </div>
  );
};

export default Index;
